import { Card, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';

const Column = ({ label, value = '-' }: { label: string; value?: string }) => {
  return (
    <Col xs={6} xl={3}>
      <h5>{label}</h5>
      <OverlayTrigger overlay={<Tooltip>{value}</Tooltip>}>
        <p className="text-truncate">{value}</p>
      </OverlayTrigger>
    </Col>
  );
};

const InstitutionProfileInfoCard = () => {
  const user = useSelector((state: RootState) => state.user.user);

  return (
    <Card className="h-100">
      <Card.Body>
        <div className="border-bottom border-dashed mb-4">
          <h4 className="mb-3 lh-sm lh-xl-1">Account Information</h4>
        </div>
        <Row>
          <Column label="Year Established" value={user.info.year} />
          <Column
            label="Address"
            value={
              typeof user.info.address === 'string' ? user.info.address : '-'
            }
          />
          <Column
            label="Contact Person Name"
            value={user.info.contactPersonName}
          />
          <Column
            label="Contact Person Designation"
            value={user.info.contactPersonDesignation}
          />
          <Column
            label="Contact Person Phone Number"
            value={user.info.contactPhoneNumber}
          />
          <Column label="Contact Person Email" value={user.info.contactEmail} />
        </Row>
      </Card.Body>
    </Card>
  );
};

export default InstitutionProfileInfoCard;
